import {
  BrowserRouter,
  Route,
  Routes
} from 'react-router-dom';

import IntegradorPage from './pages/integrador';
import FakePage from './pages/fake';
import TokenPage from './pages/token';
import VendaPage from './pages/venda';
import PaginaErro from './pages/pagina_erro';
import EditProduto from './pages/edit_produto';
import PropostaPage from './pages/proposta';
import PropostaDetalhePage from './pages/proposta_detalhe';
import PesquisaPage from './pages/pesquisa';
import PesquisaFiltroPage from './pages/pesquisa_filtro';

function App() {
  return (
      <Routes>
          <Route path="/" element={<TokenPage/>}/>
          <Route path="/integrador/*" element={<IntegradorPage/>}/>
          <Route path="/pesquisa" element={<PesquisaPage/>}/>
          <Route path="/pesquisa_filtro" element={<PesquisaFiltroPage/>}/>
          <Route path="/venda" element={<VendaPage/>}/>
          <Route path="/erro" element={<PaginaErro/>}/>
          <Route path="/fake" element={<FakePage/>}/>
          <Route path="/editarproduto" element={<EditProduto/>}/>
          <Route path="/proposta" element={<PropostaPage/>}/>
          <Route path="/proposta_detalhe" element={<PropostaDetalhePage/>}/>
          <Route path="*" element={<PaginaErro/>}/>
      </Routes>
  );
}

export default App;